import { PlanTypes } from 'mbs-ui-shared@models/PlanTypes.enum';
import { WizardHelpersSettings } from 'wizards/helpers/bases/base-for-steps-helper';
import { PlanDataFromStepsHelper } from 'wizards/helpers/plan-data-from-steps-helper/plan-data-from-steps-helper';
import { SQLFormModel } from 'wizards/models/SQL/sql-form-model';
import { BaseForPlanHelper } from 'wizards/models/base/base-models/base-for-plan-helper';

export class SQLPlanFromStepsHelper extends BaseForPlanHelper {
  public static SQLModel: SQLFormModel = null;

  public static getUpdatedPlan(plan, model: SQLFormModel, settings: WizardHelpersSettings): any {
    const newPlan = Object.assign({}, plan);

    this.SQLModel = model;
    this.updateModel(newPlan, settings);

    return newPlan;
  }

  static updateModel(newPlan, settings: WizardHelpersSettings): void {
    PlanDataFromStepsHelper.updateNewPlanByNameStep(newPlan, this.SQLModel.planNameStep);
    PlanDataFromStepsHelper.updateNewPlanByWhereBackupStep(newPlan, this.SQLModel.whereBackupStep, this.isNBF || this.isUnix);

    PlanDataFromStepsHelper.updateNewPlanBySQLServerInstance(newPlan, this.SQLModel.sqlServerInstanceStep);
    PlanDataFromStepsHelper.updateNewPlanBySQLSourceDatabases(newPlan, this.SQLModel.sqlSourceDatabasesStep);

    PlanDataFromStepsHelper.updateNewPlanFromAdvancedClassOrTier(
      newPlan,
      this.SQLModel.advancedOptionsStep,
      this.SQLModel.advancedOptionsFlags
    );
    PlanDataFromStepsHelper.updateNewPlanByCompressionEncryptionStep(newPlan, this.SQLModel.compressionEncryptionStep, this.isNBF);
    PlanDataFromStepsHelper.updateNewPlanByRetentionPolicyStep(
      newPlan,
      this.SQLModel.retentionPolicyStep,
      this.SQLModel.whereBackupStep.IsHybridBackup,
      false,
      PlanTypes.DataBasePlan
    );
    PlanDataFromStepsHelper.updateNewPlanByScheduleStep(
      newPlan,
      this.SQLModel.scheduleStep,
      this.SQLModel.scheduleAdvancedStep,
      this.SQLModel.simpleScheduleStep,
      this.isUnix,
      true
    );
    PlanDataFromStepsHelper.updateNewPlanByPrePostActionsStep(newPlan, this.SQLModel.prePostActionsStep, !settings.allowPrePostActions);
    PlanDataFromStepsHelper.updateNewPlanByNotificationStep(newPlan, this.SQLModel.notificationStep);
    PlanDataFromStepsHelper.preparePlanForSending(newPlan, !settings.isRD);
  }
}
